var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shrink-1",attrs:{"id":"ranking_pay_lock"},on:{"click":function($event){return _vm.open('premiumRanking')}}},[_vm._t("body")],2)}
var staticRenderFns = []
export { render, staticRenderFns }